export default __webpack_public_path__ + "static/PMG_EGTB_HOHH_PDS_BANCA_ENG-33ce1240ce86a37e9287bc6f3d795c63.pdf";